import TradingItems from './sku-map-trading-items-list-screen.vue';

export default {
    components: {
        'trading-items': TradingItems
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            senderId: this.$route.params.senderId ?? 0,
            receiverId: this.$route.params.receiverId ?? 0,
            model: this.emptyModel(),
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.senderId = this.$route.params.senderId ?? 0;
            this.receiverId = this.$route.params.receiverId ?? 0;
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
                SenderId: 0,
                SenderName: '',
                SenderCode: 0,
                ReceiverId: 0,
                ReceiverName: '',
                ReceiverCode: 0
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/sku_map_applications/load/' + this.appId + '/' + this.senderId + '/' + this.receiverId;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.tradingItems.channelSettings = {
                    SenderId: this.model.SenderId,
                    SenderName: this.model.SenderName,
                    SenderCode: this.model.SenderCode,
                    ReceiverId: this.model.ReceiverId,
                    ReceiverName: this.model.ReceiverName,
                    ReceiverCode: this.model.ReceiverCode,
                    ApplicationId: this.model.AppId
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}